import { useContext } from 'react';
import { TeamRolesPanelContext } from './TeamRolesPanelContext';

export const useTeamRolesPanelContext = () => useContext(TeamRolesPanelContext);
